import React, { useState, useEffect } from 'react';
import { ThemeProvider } from '@mui/material';
import { NylasScheduling } from '@nylas/react';
import { IntlProvider } from 'react-intl';
import { theme } from 'theme';

import { SchedulingWrapper } from './Scheduling.styles';
import { getLocaleData, getNylasCalendarConfig } from '../../helpers';

export const Scheduling = () => {
  const nylasConfig = getNylasCalendarConfig();

  const [langData, setLangData] = useState({
    currentLocale: 'en',
    messages: {},
  });

  useEffect(() => {
    handleLangData();
  }, []);

  const handleLangData = async () => {
    const data = await getLocaleData();
    setLangData(data);
  };

  if (!langData) {
    return null;
  }

  return (
    <IntlProvider
      messages={langData.messages}
      locale={langData.currentLocale}
      defaultLocale="en"
    >
      <ThemeProvider theme={theme}>
        <SchedulingWrapper className={'mt-5'}>
          <NylasScheduling
            configurationId={nylasConfig?.configId}
            schedulerApiUrl={nylasConfig?.domain}
            enableUserFeedback={false}
          />
        </SchedulingWrapper>
      </ThemeProvider>
    </IntlProvider>
  );
};
